const UPI_TIMER_PREFIX = "upi_timer";

export const UPI_TIMER_TEST_IDS = {
    CONTAINER: `${UPI_TIMER_PREFIX}_container`,
    HEADING: `${UPI_TIMER_PREFIX}_heading`,
    TITLE: `${UPI_TIMER_PREFIX}_title`,
    META: `${UPI_TIMER_PREFIX}_meta`,
    CANCEL_PAYMENT_LINK: `${UPI_TIMER_PREFIX}_cancel`,
};
